<template>
    <a href="javascript:;" v-if="visibleProduct" class="machine-card" :style="cssVars" :class="{'is-selected': isSelected, 'is-bestseller': isBestSeller, 'isNew' : isNew}" @click="machineSelected()">
        <img :src="datas.thumbnail" alt="" class="picture" />
        <div class="category" v-show="false" v-if="datas.parent_category">{{ datas.parent_category.label }}</div>
        <div class="category" v-show="false" v-if="datas.family">{{ datas.family.label }}</div>
        <div class="title" v-if="datas.name" :class="brandColor">{{ datas.name }}</div>
        <div class="title" v-if="datas.values" :class="brandColor">{{ datas.values.reference_name }}</div>

        <ul class="machine-card-attributes" v-if="!hide" >
            <card-label-value-item
                v-for="attribute in minimalAttributes"
                :key="attribute.attribute"
                :label-value="attribute"
            />
        </ul>

        <b-checkbox
            v-model="isSelected"
            v-if="selectable"
            type="is-brand"
            size="is-large"
            :value="defaultCheckValue"
        />
        <span class="bottom-icon icon-arrow-right" :class="brandColor" v-if="!selectable"></span>
        <div class="shield" v-if="selectable"></div>
    </a>
</template>

<script>
    //import mediaService from '@/services/akeneo/media'

    import {mapState} from "vuex";
    import CardLabelValueItem from "@/components/LabelValue/CardLabelValueItem";

    const defaultPicture = require('@/assets/img/no_image_available.jpg');
    const loadingGif = require('@/assets/img/pix.png');

    export default {
        name: 'MachineCard',
      components: {
        CardLabelValueItem,
      },
        props: {
            datas: {
                type: Object,
                default:null
            },
            saveRoute: {
                type: Boolean,
                default: true
            },
            selectable: {
                type: Boolean,
                default: false
            },
            maxSelect: {
                type: Number,
                default: null
            },
            disabledSelection: {
                type: Boolean,
                default: false
            },
            defaultSelected: {
                type: Array,
                default: () => []
            },
          hide : {
              type: Boolean,
            default:false,
          }
        },
        data() {
            return {
                picture: defaultPicture,
                isSelected: false,
                isBestSeller:false,
                isNew:false,
                defaultCheckValue: false,
                bestSellerFinitions: [],
                minimalAttributes: []
            }
        },
        computed: {
          ...mapState({
            category: state => state.searchMachines.category,
            unitType:state=>state.settings.unitType,
            filtersList: state=>state.searchMachines.filtersList,
            firstLoad : state=>state.searchMachines.firstLoad
          }),
          cssVars() {
            return {
              '--new-label': "'"+this.$t('new')+"'",
            }
          },
          visibleProduct() {
            if(!this.firstLoad && this.minimalAttributes) {
              let retour=true
              this.minimalAttributes.forEach((attribute)=>{
                if(attribute.value===' - ') retour=false
              })

              return retour
            } return true
          }
        },
        watch: {
            datas: function() {
                this.picture = defaultPicture;
                this.isBestSeller=this.datas.best_seller && this.getEnv !== 'production' && this.$store.state.settings.region==='R1'
                this.isNew=this.datas.isNew
                //this.fetchPicture();
            },
        },
        created() {
            //this.fetchPicture();
            this.fetchMinimalAttributes();
            if(this.selectable && this.defaultSelected.length > 0 && this.defaultSelected.includes(this.datas.identifier)){
                this.defaultCheckValue = true
                this.isSelected = true
            }
        },
        methods: {

            fetchPicture() {
                if (this.datas.thumbnail) {
                    this.picture = this.datas.thumbnail;
                    /*this.picture = loadingGif;
                    return mediaService
                    .get(this.datas.mainVisual, {
                        size: 'thumbnail'
                    })
                    .then(response => {
                        if (response.data.code === 200)
                            this.picture = response.data.data
                        else
                            this.picture = defaultPicture;
                    });*/
                } else {
                 // console.log(this.datas)
                  //this.picture=this.datas.main_visual
                    //this.picture = defaultPicture;
                    //this.picture = loadingGif;
                    //return mediaService
                    //.get(this.datas.values.main_visual, {
                    //    size: 'thumbnail'
                    //})
                    //.then(response => {
                    //    if (response.data.code === 200)
                    //        this.picture = response.data.data
                    //    else
                    //        this.picture = defaultPicture;
                    //});
                }
            },

          fetchMinimalAttributes() {
            var count = 1
            if (this.filtersList.length > 0) {
              this.filtersList.forEach((x) => {
                var attribute = this.datas.minimalAttributes.find((y) => y.code === x.attribute)
                var val = " - ";
                var code = "";
                if (attribute) {
                  val = attribute.value.display[this.unitType]
                  code = attribute.code
                }
                this.minimalAttributes.push({'label': x.title, 'value': val, 'code': code});
                count++
              })
            } else {
              for (let i = 0; i < 3; i++) {
                var attribute = this.datas.minimalAttributes[i]
                var val = " - ";
                var code = "";
                if (attribute) {
                  val = attribute.value.display[this.unitType]
                  code = attribute.code
                }
                this.minimalAttributes.push({'label': attribute.label, 'value': val, 'code': code});
              }
            }
          },
            machineSelected() {
                if(this.selectable) {
                    if(!this.disabledSelection || (this.disabledSelection && this.isSelected)){
                        this.isSelected = !this.isSelected;
                        this.$emit('machineSelected', this.isSelected)

                    }
                    else {
                        this.$toast.open({
                            message: this.$tc('you_cannot_select_more_than_x_machines', this.maxSelect),
                            type: 'is-warning',
                            duration: 1500
                        })
                    }
                }
                else{
                    this.$router.push({ name: 'machine-sheet-summary', params: {id: (this.datas.parent ? this.datas.parent : this.datas.identifier), name: this.slugifyName(this.datas), saveRoute: this.saveRoute, openBestSellerPanel:(this.category.code === 'best-seller')}});
                }
            }
        }
    }
</script>

<style lang="scss">
    .machine-card {
        flex: 0 0 auto;
        position: relative;
        display: block;
        width: 200px;
        height: auto;
        padding: 0 25px 35px;
        text-align: center;
        border-radius: 20px;
        box-shadow: 20px 20px 74px 0 rgba(0, 0, 0, 0.15);
        background-color: $white;
        border: solid 2px $white;
        transition: border-color 0.3s ease;

        @media #{$mq_phone} {
            height: auto;
        }

        @each $brand in $brands {
            .brand-#{$brand} & {
                &:hover, &.is-selected {
                    border: solid 2px brand-color($brand);
                }
                .brand-color {
                  color: brand-color($brand)
                }
            }
        }


        &.is-bestseller {
            &:before {
                content: '';
                position: absolute;
                top: 9px;
                left: 9px;
                width: 73px;
                height: 34px;
                background-image: url('~@/assets/img/best-seller.png');
                background-size: 73px 34px;
            }
        }

      &.is-new {
        &:after {
         content: var(--new-label);

          position: absolute;
          top: 9px;
          right: 9px;
          //width: 73px;
          //height: 34px;
          background-color: #eb1212;
          color:#ffffff;
          border-radius:30px;
          padding:5px 15px;
          font-size:10px;
         // background-size: 73px 34px;
        }
      }

        .picture {
            padding-top: 20px;
            width: auto;
            height: 145px;

            //@media #{$mq_tablet} {
            //    padding-top: 10px;
            //    height: 130px;
            //}

            @media #{$mq_phone} {
                padding-top: 10px;
                height: 140px;
            }
        }

        .category {
            font-size: 10px;
            font-weight: 500;
            line-height: 1.3;
            text-transform: uppercase;
            color: $cloudy-grey;
        }

        .title {
            font-family: $font_manitou;
            font-size: 11px;
            line-height: 1.1;
            text-transform: uppercase;
            margin-top: 5px;
        }

        .checkbox {
            margin-top: 10px;

            .control-label {
                display: none;
            }
        }

      .machine-card-attributes {
        margin-top:20px;
      }

        .bottom-icon {
            position: absolute;
            bottom: 15px;
            left: 0;
            right: 0;
            text-align: center;
            font-size: 10px;

            @media #{$mq_phone} {
                bottom: 20px;
            }
        }

        .shield {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 2;
        }
    }
</style>
